import React from 'react';
import FadeInOnScroll from '../../../../../../components/FadeInOnScroll';

import ContainerLine from "../../../../../../components/UIComponents/ContainerLine";
import { ContainerLineUI } from "../../../../../../components/UIComponents/ContainerLine/styles";

import { ParagraphUI } from "../../../../../../components/UIComponents/Paragraph/styles";
import { ParagraphHighlightUI, TitleHighlightUI } from '../../../../../../components/UIComponents/TitleHighlight/styles';
import VideoBackground from "../../../../../../components/VideoBackground";
import { urlWebsite } from "../../../../../../config";
import RenderPageList from '../../modules/RenderList';
import RenderPageImages from "../../modules/RenderPageImages";
import RenderVideoList from '../../modules/RenderVideoList2';

const VideoGalleryPageTemplate = ({ pageContent, theme }: Record<string, any>) => {
  const { hash } = pageContent;

  return (
    <>

      <ContainerLineUI className='pad-container full-width' id={hash} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: pageContent?.orientation === 'column' ? 'column' : 'row', background: pageContent?.theme_data?.background ? pageContent?.theme_data?.background : '#fff' }} >
        {pageContent?.theme_data?.hide_side_content !== 'yes' ? <div className='row-to-column full-width  gap' style={{ justifyContent: 'flex-start', maxWidth: '1000px' }} >
          <div className='column-start full-width  max-600' >
            {pageContent?.theme_data?.show_title !== 'no' ? <TitleHighlightUI color={pageContent?.theme_data?.title_color ? pageContent?.theme_data?.title_color : '#333'} background={pageContent?.theme_data?.title_background ? pageContent?.theme_data?.title_background : ''} style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: pageContent?.title }} /> : <></>}
            <FadeInOnScroll><ParagraphHighlightUI style={{ marginTop: '15px', textAlign: 'left' }} color={pageContent?.theme_data?.text_color ? pageContent?.theme_data?.text_color : '#333'} className='midTitle max-600 text-center' dangerouslySetInnerHTML={{ __html: pageContent?.description || '' }} /></FadeInOnScroll>
          </div>


          {pageContent?.map_link ? <div style={{ width: '100%', maxWidth: '400px', borderRadius: '15px', overflow: 'hidden' }}  > <iframe src={pageContent?.map_link} width="600" height="450" style={{ 'border': 0 }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe> </div> : <></>}

          {pageContent?.video ? <VideoBackground path={pageContent?.video} /> : <></>}
          {pageContent?.data_list?.length > 0 ? <FadeInOnScroll><RenderVideoList inactiveColor={pageContent?.theme_data?.text_color} color={pageContent?.theme_data?.title_color} background={pageContent?.theme_data?.title_background} list={pageContent?.data_list} /></FadeInOnScroll> : <></>}
          {pageContent?.buttons?.length > 0 ? <div style={{ margin: '0px auto' }}>
            {pageContent?.buttons && pageContent?.buttons.map((itemButton: Record<string, any>) => {
              return <a href={`${itemButton.link}`} ><FadeInOnScroll><button className={itemButton.class_name || 'greenButton2 shadow'} style={{ background: theme?.button_background, color: theme?.button_color }}>{itemButton.title}</button></FadeInOnScroll></a>
            })}
          </div> : <></>}
        </div> : <></>}
      </ContainerLineUI>
    </>
  );


}

export default VideoGalleryPageTemplate;